const tableColumnMetadata: any[] = [
  { key: 'creationDate', displayName: 'Fecha' },
  { key: 'sendType', displayName: 'Tipo' },
  { key: 'message', displayName: 'Mensaje' }
];

export default tableColumnMetadata;
